module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"values":{"cpu":"{n} шт.","ram":"{n} Мб.","disk":"{n} Гб.","networkDisk":"{n} Гб."},"os":"Источник","name":"Тип конфигурации","total":"Общая цена","cpu":"vCPU","ram":"Память","disk":"Локальный диск","networkDisk":"Сетевой диск"}}')
  delete Component.options._Ctor
}
